exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aside{\r\n  height: 100%;\r\n}\r\n\r\n.resultados{\r\n  padding-top: 2%;\r\n  height: 13%;\r\n}\r\n\r\n.chip {\r\n    display: inline-block;\r\n    padding: 0 5px;\r\n\r\n    height: 30px;\r\n    font-size: 12px;\r\n    line-height: 30px;\r\n    border-radius: 25px;\r\n    background-color: #f2dab3;\r\n}\r\n\r\n.closebtn {\r\n    padding-left: 10px;\r\n    color: #888;\r\n    font-weight: bold;\r\n    float: right;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n\r\n.closebtn:hover {\r\n    color: #000;\r\n}\r\n\r\n.list{\r\n  height: 97%;\r\n  width: 100%;\r\n  padding-right: 2%;\r\n\r\n  overflow-y: scroll;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.btn-primary{\r\n  background-color: #f27b24 !important;\r\n  border-color: #f27b24 !important;\r\n}\r\n\r\n@media only screen and (min-width: 200px) and (max-width: 1000px){\r\n    .resultados {\r\n        height: 100px;\r\n        padding: 0;\r\n        padding-top: 10px;\r\n    }\r\n\r\n    .list {\r\n      padding: 0;\r\n      padding-bottom: 5px;\r\n      margin-bottom: 0px;\r\n    }\r\n\r\n    .aside{\r\n      height: 500px;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/app/aside/aside.component.css
// module id = ../../../../../src/app/aside/aside.component.css
// module chunks = main